<template lang="pug">
//- home-main
.home-main
  .hello-word Hi , {{ $root.user.name }} !
  .hello-text 讓我們來看看你今天有哪些課程。

  //- 切換 您的課程 / 推薦課程 按鈕
  .switch-button-box
    .home-switch-btn.button(
      v-bind:class="!switch_status ? 'btn-default' : 'btn-no-default'",
      @click="clickSwitch(false)"
    ) 您的課程
    //- .home-switch-btn.button(
    //-   v-bind:class="switch_status ? 'btn-default' : 'btn-no-default'",
    //-   @click="clickSwitch(true)"
    //- ) 推薦課程

  //- banner 位置
  BigBanner(v-if="binBannerUri" :img="binBannerUri" @closeWindow="binBannerUri = ''")
  .home-banner-view(v-if="showBanner")
    .banner-items
      carousel(
        items="1",
        :autoplay="true",
        :dots="false",
        :nav="false",
        :margin="15",
        :loop="true"
      )
        .nav-content(v-for="(banner, index) in banners")
          img.nav-img(
            :src="banner.image",
            @click="openBanner(banner.content.image)"
          )

  hr

  //- 日期組件
  DateCom(
    use_type="home",
    :date_turn="date_turn",
    :date_filter="date_filter",
    @dateTurn="dateTurn",
    @setDate="setCourseDate"
  )
  //- 今日推薦
  TodayRecommend

  //- 懸浮廣告視窗
  .floating-ad-overlay(v-if="showFloatingAd" @click="closeFloatingAd")
    .floating-ad-container(@click.stop)
      .floating-ad-content
        img.floating-ad-image(:src="$root.full_ad_image_uri" @click="openFloatingAdLink")
        .countdown-display(v-if="countdown > 0")
          span.countdown-text {{ countdown }}s
        .floating-ad-close-btn(
          v-if="countdown <= 0"
          @click="closeFloatingAd"
        )
          span.close-icon ×
</template>
<script>
import carousel from 'v-owl-carousel'
import DateCom from '@/components/date'
import TodayRecommend from '@/components/home/today-recommend'
import BigBanner from '@/components/big-banner.vue'
export default {
  name: 'homeMain',
  props: ['switch_status'],
  components: {
    DateCom,
    carousel,
    TodayRecommend,
    BigBanner
  },
  data () {
    return {
      //- 課程表格切換
      timetable_switch: false,
      //- 日期開關
      date_turn: false,
      //- 日期篩選狀態
      date_filter: this.$root.common.getNowTime('date'),
      //- 語言篩選狀態
      language_filter: 'all',
      //- 課程篩選狀態
      class_filter: 'all',
      banners: [],
      showBanner: false,
      binBannerUri: '',
      //- 懸浮廣告相關
      showFloatingAd: false,
      countdown: 5,
      countdownTimer: null
    };
  },
  created () {
    this.getBannerData()
    this.getTopBannerInfo()
  },
  beforeDestroy () {
    // 組件銷毀前清除計時器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  },
  watch: {
    // 監聽全局懸浮廣告狀態
    '$root.show_full_ad_view': {
      handler (newVal) {
        if (newVal && this.$root.full_ad_image_uri) {
          this.openFloatingAd()
        }
      },
      immediate: true
    }
  },
  methods: {
    dateTurn () {
      this.$data.date_turn = !this.$data.date_turn
    },
    switchTimeTable (_status) {
      this.timetable_switch = _status
    },
    //- 切換右方時間表
    clickSwitch (_status) {
      this.$emit('clickSwitch', _status)
    },
    // 設定課程語言
    setCourseLange (_langID) {
      this.language_filter = _langID
    },
    // 設定課程類別
    setCourseType (_courseType) {
      this.class_filter = _courseType
    },
    // 設定課程日期
    setCourseDate (_courseDate) {
      this.date_filter = _courseDate
    },
    // 獲取 Banner 資料
    async getBannerData () {
      await this.$root.apis.getBannerInfo(1, this.processGetBannerSuccess, this.processStatusError)
    },
    // 成功獲取 Banner
    async processGetBannerSuccess (_response) {
      this.banners = _response.body
      setTimeout(() => {
        this.showBanner = true
      }, 500);
    },
    // 開啟 Banner
    openBanner (_url) {
      console.log('--> 顯示大圖圖片:', _url)
      this.binBannerUri = _url
    },
    // 獲得懸浮廣告資訊
    getTopBannerInfo () {
      let vm = this
      this.$root.apis.getBannerInfo(2, function (_response) {
        let images = _response.body
        if (images.length > 0) {
          vm.$root.full_ad_image_uri = images[0].image
          vm.$root.show_full_ad_view = true
          // 顯示懸浮廣告
          vm.openFloatingAd()
        }
      }, this.processStatusError)
    },
    // 開啟懸浮廣告視窗
    openFloatingAd () {
      console.log('--> 顯示懸浮廣告:', this.$root.full_ad_image_uri)
      this.showFloatingAd = true
      this.countdown = 5 // 設置倒數計時為5秒
      this.startCountdown()

      // 等待圖片加載完成後調整容器尺寸
      this.$nextTick(() => {
        this.adjustContainerSize()
      })
    },
    // 調整容器尺寸以適應圖片比例
    adjustContainerSize () {
      const img = new Image()
      img.onload = () => {
        const imgRatio = img.width / img.height
        const maxWidth = window.innerWidth * 0.9
        const maxHeight = window.innerHeight * 0.75

        let containerWidth, containerHeight

        if (imgRatio > maxWidth / maxHeight) {
          // 圖片較寬，以寬度為準
          containerWidth = maxWidth
          containerHeight = maxWidth / imgRatio
        } else {
          // 圖片較高，以高度為準
          containerHeight = maxHeight
          containerWidth = maxHeight * imgRatio
        }

        // 設置容器尺寸
        const container = document.querySelector('.floating-ad-container')
        if (container) {
          container.style.width = containerWidth + 'px'
          container.style.height = containerHeight + 'px'
        }
      }
      img.src = this.$root.full_ad_image_uri
    },
    // 開始倒數計時
    startCountdown () {
      // 清除之前的計時器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }

      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
      }, 1000)
    },
    // 關閉懸浮廣告視窗
    closeFloatingAd () {
      if (this.countdown > 0) {
        return // 如果倒數還沒結束，不允許關閉
      }

      this.showFloatingAd = false
      this.countdown = 5

      // 清除計時器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    // 開啟懸浮廣告連結
    openFloatingAdLink () {
      console.log('--> 開啟懸浮廣告連結')
      // 這裡可以實現開啟連結的邏輯
      // 例如：window.open(this.floatingAdLink, '_blank')
    }
  }
}
</script>

<style lang="css" scoped>
.home-banner-view {
  width: 100%;
  text-align: right;
  clear: both;
}

.home-banner-view .banner-items {
  cursor: pointer;
}

/* 懸浮廣告樣式 */
.floating-ad-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-in-out;
}

.floating-ad-container {
  position: relative;
  max-width: 90vw;
  max-height: 75vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.floating-ad-content {
  position: relative;
  display: flex;
  flex-direction: column;
}

.floating-ad-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.floating-ad-image:hover {
  transform: scale(1.02);
}

.floating-ad-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.floating-ad-close-btn:hover:not(.disabled) {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.floating-ad-close-btn.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.close-icon {
  font-size: 20px;
  line-height: 1;
}

/* 倒數計時顯示 */
.countdown-display {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.countdown-text {
  font-size: 14px;
  line-height: 1;
  font-weight: bold;
}

/* 動畫效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: scale(0.8) translateY(-20px);
    opacity: 0;
  }

  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

/* 響應式設計 */
@media (max-width: 768px) {
  .floating-ad-container {
    max-width: 95vw;
    max-height: 75vh;
  }

  .floating-ad-close-btn {
    width: 35px;
    height: 35px;
    top: 8px;
    right: 8px;
  }

  .countdown-display {
    width: 35px;
    height: 35px;
    top: 8px;
    right: 8px;
  }

  .close-icon {
    font-size: 16px;
  }

  .countdown-text {
    font-size: 12px;
  }
}
</style>